// Page de connexion.
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthLayout from "@/components/AuthLayout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Mail, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [erreur, setErreur] = useState("");
  const [chargement, setChargement] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    setChargement(true);
    const res = await login(email, password);
    setChargement(false);
    if (res.ok) navigate(res.user?.role === "admin" ? "/admin/abonnements" : "/tableau-de-bord");
    else setErreur(res.message);
  };

  return (
    <AuthLayout titre="Connexion" sousTitre="Accédez à votre espace de gestion.">
      <form onSubmit={soumettre} className="space-y-5" data-testid="formulaire-connexion">
        {erreur && (
          <div
            data-testid="message-erreur"
            className="rounded-md bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700"
          >
            {erreur}
          </div>
        )}
        <div className="space-y-1.5">
          <Label htmlFor="email" className="text-[#1D3D3D] font-semibold">Adresse email</Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A8A8A]" />
            <Input
              id="email"
              type="email"
              data-testid="champ-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@entreprise.pf"
              required
              className="pl-10 bg-white border-[#4A8A8A]/30 focus-visible:ring-[#4A8A8A]"
            />
          </div>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password" className="text-[#1D3D3D] font-semibold">Mot de passe</Label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#4A8A8A]" />
            <Input
              id="password"
              type="password"
              data-testid="champ-mot-de-passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="pl-10 bg-white border-[#4A8A8A]/30 focus-visible:ring-[#4A8A8A]"
            />
          </div>
          <div className="text-right">
            <Link
              to="/forgot-password"
              data-testid="lien-mot-de-passe-oublie"
              className="text-sm text-[#4A8A8A] hover:text-[#2D5A5A] font-medium"
            >
              Mot de passe oublié ?
            </Link>
          </div>
        </div>
        <Button
          type="submit"
          data-testid="bouton-connexion"
          disabled={chargement}
          className="w-full bg-[#1D3D3D] hover:bg-[#2D5A5A] text-white font-semibold h-11"
        >
          {chargement ? <Loader2 className="h-4 w-4 animate-spin" /> : "Se connecter"}
        </Button>
        <p className="text-center text-sm text-[#1D3D3D]/70">
          Pas encore de compte ?{" "}
          <Link to="/register" data-testid="lien-inscription" className="text-[#4A8A8A] hover:text-[#2D5A5A] font-semibold">
            Créer un compte
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
}
